import axios from 'axios';
import aesjs from 'aes-js';
import autoBind from 'auto-bind';
import {AUTH_COOKIE} from '@/state/modules/auth';

export default class ReLogin {
  constructor() {
    autoBind(this);
    this.aesKey = new TextEncoder().encode('65Xuta2VK9vM64u5zEELnfnMGGSATz5g');
  }

  get itemKey() {
    return AUTH_COOKIE + '-relogin';
  }

  get cryptoCtr() {
    return new aesjs.ModeOfOperation.ctr(this.aesKey, new aesjs.Counter(5));
  }

  encrypt({email, password}) {
    if (!process.browser) return;
    if (!window || !window.localStorage) return;

    const data = JSON.stringify({email, password});
    const encrypt = aesjs.utils.hex.fromBytes(this.cryptoCtr.encrypt(aesjs.utils.utf8.toBytes(data)));
    window.localStorage.setItem(this.itemKey, encrypt);
  }

  decrypt() {
    if (!process.browser) return;
    if (!window || !window.localStorage) return;

    const data = window.localStorage.getItem(this.itemKey);
    if (!data) return false;

    const decrypt = aesjs.utils.utf8.fromBytes(this.cryptoCtr.decrypt(aesjs.utils.hex.toBytes(data)));
    return JSON.parse(decrypt);
  }

  async run() {
    const decrypt = this.decrypt();
    if (!decrypt) return false;

    const result = await axios.post(`/auth/api/v1/login`, decrypt);
    if (result.success) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + result.success.token;
    }

    return result;
  }
}
